import styled from "styled-components";

export const CardDockCapacityIndicator = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: center;
  overflow: visible;
`;
